import moment from "moment";
import { DATE_FORMATS } from "utils/Date";

const mocks = {
  buildTimeSlots() {
    const now = moment();

    return [
      // 5 before
      now.clone().subtract(1, "h"),
      now.clone().subtract(1, "d"),
      now.clone().subtract(1, "M"),
      now.clone().subtract(1, "Q"),
      now.clone().subtract(1, "y"),

      // now
      now.clone(),

      // 5 after
      now.clone().add(1, "h"),
      now.clone().add(1, "d"),
      now.clone().add(1, "M"),
      now.clone().add(1, "Q"),
      now.clone().add(1, "y"),
    ].map((date, id) => ({
      id,
      planned_date_time_from: date.format(DATE_FORMATS.BUMBAL),
      occupiedMin: 0,
      durationMin: 100,
      planned: true,
    }));
  },
  appointmentHistory: [
    {
      id: 1,
      endProductTypeName: "Type 1",
      treatmentName: "Phase 1",
      planned_date_time_from: moment().format(DATE_FORMATS.BUMBAL),
    },
    {
      id: 2,
      endProductTypeName: "Type 1",
      treatmentName: "Phase 2",
      planned_date_time_from: moment().format(DATE_FORMATS.BUMBAL),
    },

    {
      id: 3,
      endProductTypeName: "Type 2",
      treatmentName: "Phase 1",
      planned_date_time_from: moment().format(DATE_FORMATS.BUMBAL),
    },
    {
      id: 4,
      endProductTypeName: "Type 2",
      treatmentName: "Phase 2",
      planned_date_time_from: moment().format(DATE_FORMATS.BUMBAL),
    },

    {
      id: 5,
      endProductTypeName: "Type 3",
      treatmentName: "Phase 1",
      planned_date_time_from: moment().format(DATE_FORMATS.BUMBAL),
    },
    {
      id: 6,
      endProductTypeName: "Type 3",
      treatmentName: "Phase 2",
      planned_date_time_from: moment().format(DATE_FORMATS.BUMBAL),
    },
  ],
};

export default mocks;
